import styled from 'styled-components';

export const HomeContainer = styled.div`
	.section {
	}

	section#banner {
		display: flex;
		align-items: center;

		min-height: 78rem;

		.content {
			position: relative;
			z-index: 100;

			.text {
				position: relative;
				z-index: 10;

				display: flex;
				flex-direction: column;
				gap: 2rem;

				h6,
				small {
					display: flex;
					flex-direction: row-reverse;
					gap: 1.2rem;

					width: fit-content;
					padding: 1rem 1.6rem;

					font-size: calc(var(--text-size) - 0.2rem);
					font-weight: 500;
                    color: var(--color-title);

					background: var(--color-surface);
					border-radius: var(--border-radius);

					svg {
						font-size: var(--text-size);
					}
				}

				h1 {
					font-size: calc(var(--title-size) + 1.8rem);
					line-height: 1.4;

					width: 100%;
					/* width: 79rem; */

					font-weight: 300;

					span {
						font-weight: bold;
					}

					br.tablet {
						display: none;
					}
				}

				p {
					width: 52rem;

					font-size: var(--text-size);
					line-height: 1.5;
				}

				.buttons {
					display: flex;
					gap: 1.2rem;

					margin-top: 2rem;
				}
			}

			.gradient {
				--size: 250px;
				--speed: 50s;
				--easing: cubic-bezier(0.8, 0.2, 0.2, 0.8);

				position: absolute;
				top: 50%;
				/* top: 0; */
				right: 0;
				transform: translateY(-50%);

				width: var(--size);
				height: var(--size);

				filter: blur(calc(var(--size) / 5));

				background-image: var(--gradient);
				border-radius: 30% 70% 70% 30%/30% 30% 70% 70%;

				animation: rotate var(--speed) var(--easing) alternate infinite;

				opacity: 0.3;
			}

			@media (min-width: 720px) {
				.gradient {
					--size: 500px;
				}
			}

			@keyframes rotate {
				0% {
					transform: translateY(-50%) rotate(0deg);
				}

				100% {
					transform: translateY(-50%) rotate(360deg);
				}
			}
		}
	}

	section#our-numbers {
		margin-top: -2rem;

		.content {
			padding: 0 0 8rem;

			.our-numbers {
				display: grid;
				grid-template-columns: repeat(4, 1fr);
				gap: 3.2rem;

				.numbers-item {
					display: flex;
					flex-direction: column;
					align-items: flex-start;
					gap: 1.2rem;

					width: 100%;

					strong {
						color: #fff;
						font-size: calc(var(--title-size) + 2.2rem);

						small {
							font-size: 50%;
						}
					}

					p {
						font-size: calc(var(--text-size) + 0.2rem);
						line-height: 150%;

						opacity: 0.8;
					}
				}
			}
		}
	}

	section#projects {
		.content {
			border-bottom: 1px solid var(--color-line);

			.heading {
				width: 80rem;
			}

			.projects {
				display: grid;
				grid-template-columns: 1fr 1fr;
				gap: 6rem;

				width: 100%;
			}

			.footering {
				display: flex;
				justify-content: space-between;

				width: 100%;

				.text {
					width: 40rem;

					p {
						font-size: var(--text-size);
						line-height: 1.4;
					}
				}
			}
		}
	}

	section#how-it-works {
		.content {
			.heading {
				width: 100%;

				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;

				h1 {
					text-align: left;
					width: 676px;
				}
			}

			.how-it-works {
				position: relative;
				display: flex;
				justify-content: space-between;
				align-items: flex-start;

				width: 100%;

				.steps {
					display: flex;
					flex-direction: column;
					gap: 4.8rem;

					width: 32rem;

					.step {
						position: relative;
						display: flex;
						flex-direction: column;
						gap: 1.2rem;

						opacity: 0.7;
						transition: 0.1s;
						cursor: alias;

						&:hover {
							opacity: 1;
						}

						.number {
							display: flex;
							align-items: center;
							justify-content: center;

							width: 5rem;
							height: 5rem;

							border-radius: 50%;
							border: 1px solid #fff;

							font-size: calc(var(--text-size) + 0.8rem);
						}

						strong {
							color: var(--color-title);
							font-size: calc(var(--text-size) + 0.4rem);
						}

						p {
							font-size: var(--text-size);
							line-height: 1.5;
						}
					}
				}

				.infographic {
					position: sticky;
					top: 0;
				}

				> svg path {
					fill: #fff !important;
				}
			}
		}
	}

	section#faq {
		.content {
			.faq {
				display: flex;
				flex-direction: column;
				gap: 4rem;

				width: 90rem;

				.questions {
					display: flex;
					flex-direction: column;

					width: 100%;
				}
			}
		}
	}

	@media (max-width: 820px) {
		section#banner {
			min-height: 80rem;

			overflow: hidden;

			.content {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;

				.text {
					text-align: center;
					align-items: center;

					width: 100%;

					h1 {
						width: 100%;
						br {
							display: none;
						}

						br.tablet {
							display: block;
						}
					}
				}
			}
		}

		section#our-numbers {
			.content {
				.our-numbers {
					grid-template-columns: repeat(2, 1fr);
					gap: 5.2rem;

					.numbers-item {
						align-items: center;
						text-align: center;
					}
				}
			}
		}

		section#projects {
			.content {
				gap: 6rem !important;

				.heading {
					width: 100%;

					h1 {
						br {
							display: none;
						}
					}
				}

				.projects {
					gap: 3.2rem;
					margin-bottom: 2rem;
				}
			}
		}

		section#how-it-works {
			.content {
				.heading {
					flex-direction: column;
					align-items: center;

					text-align: center;

					h1 {
						text-align: center;
						width: 100%;
					}
				}

				.how-it-works {
					flex-direction: column-reverse;
					justify-content: center;
					align-items: center;
					gap: 7.2rem;

					.infographic {
						position: relative;
						background: var(--color-background);
					}

					.steps {
						display: grid;
						grid-template-columns: 1fr 1fr;

						width: 100%;

						.step {
							align-items: center;
							text-align: center;
						}
					}
				}
			}
		}

		section#faq {
			.content {
				.faq {
					width: 100%;
				}
			}
		}
	}

	@media (max-width: 720px) {
		section#banner {
			padding: 13rem 0;

			.content {
				.text {
					h1 {
						font-size: calc(var(--title-size) + 1.6rem);
						font-size: 10.05128vw;

						.scramble-text {
							display: inline-block;

							height: 101.88px;
							overflow-y: hidden;

							&::-webkit-scrollbar {
								display: none;
							}
						}
					}

					p {
						width: 100%;
					}

					.buttons {
						flex-direction: column;
						margin-top: 2.8rem;
						width: 95%;
						gap: 2rem;

						.button {
							width: 100%;
							.aresui-button {
								width: 100%;
							}
						}
					}
				}

				.gradient {
					top: 10rem;
				}
			}
		}

		section#our-numbers {
			.content {
				.our-numbers {
					grid-template-columns: repeat(1, 1fr);
				}
			}
		}

		section#projects {
			.content {
				.projects {
					grid-template-columns: 1fr;
				}

				.footering {
					flex-direction: column;
					text-align: center;
					align-items: center;
					gap: 3.2rem;

					.text {
						width: 100%;
					}
				}
			}
		}

		section#how-it-works {
			.content {
				.heading {
					width: 100%;
				}

				.how-it-works {
					.infographic {
						width: 100%;

						> div {
							width: 100%;
						}
					}

					.steps {
						grid-template-columns: 1fr;
					}
				}
			}
		}
	}
`;

export const Section = styled.section`
	.content {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 8rem;

		padding: 8rem 0 6rem;

		.heading {
			display: flex;
			flex-direction: column;
			align-items: center;
			text-align: center;

			h1 {
				font-size: calc(var(--title-size) + 0.4rem);
				line-height: 1.4;
			}
		}

		.footering {
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
	}

	@media (max-width: 820px) {
	}

	@media (max-width: 720px) {
		.content {
			gap: 6rem;
		}
	}
`;

export default HomeContainer;
